import iconClock from "../../../../design/assests/images/pdf_icons/clock.png"

export const buildHourConsumptionSection = async (
  doc,
  timeConsumptionData,
  y
) => {
  const pageWidth = doc.internal.pageSize.getWidth()
  const sideMargin = 10
  const usableWidth = pageWidth - sideMargin * 2
  const columnWidth = usableWidth / 2

  const titleColor = "#24292F"
  const labelColor = "#737E8D"
  const valueColor = "#24292F"

  const iconSize = 6.5
  const spacing = 3
  const iconOffsetY = 4.5

  doc.setFont("Cairo-Bold", "normal")
  doc.setFontSize(11)
  doc.setTextColor(titleColor)
  doc.addImage(
    iconClock,
    "PNG",
    sideMargin,
    y - iconOffsetY,
    iconSize,
    iconSize
  )
  doc.text("Consumo de horas", sideMargin + iconSize + spacing, y)
  y += 10

  doc.setFont("Mulish-Bold", "normal")
  doc.setFontSize(7.5)
  doc.setTextColor(labelColor)

  doc.text("Consumo del sprint", sideMargin, y)
  doc.text("Consumo total al corte", sideMargin + columnWidth, y)

  y += 6

  doc.setFont("Cairo-Bold", "normal")
  doc.setFontSize(11)
  doc.setTextColor(valueColor)

  const formatValue = (val, unit) =>
    val != null && val !== "" ?
      `${Number(val).toLocaleString("en-US")} ${unit}`
    : "-"

  doc.text(
    formatValue(timeConsumptionData?.consumedHoursInPeriod, "horas"),
    sideMargin,
    y
  )
  doc.text(
    formatValue(timeConsumptionData?.totalConsumedHours, "horas"),
    sideMargin + columnWidth,
    y
  )

  y += 8

  doc.setDrawColor(204, 212, 222)
  doc.setLineWidth(0.3)
  doc.line(sideMargin, y, pageWidth - sideMargin, y)

  return y + 10
}
